'use strict';

module.exports = Object.freeze({
  shared_personal_data: require('./default_shared_personal_data'),
  personal_data: require('./default_personal_data'),
  consents: require('./default_consents'),
  communication_channels: require('./default_communication_channels'),
});
